import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import {
  deleteBico,
  findBico,
  recordFiltering,
} from '~/store/modules/bico/actions';

import MyForm from './form';

function Bico() {
  const data = useSelector((state) => state.bico);

  const optionSN = useMemo(() => [
    { label: 'NAO', value: 'Não' },
    { label: 'SIM', value: 'Sim' },
  ]);

  const optionStatus = useMemo(() => [
    { label: 'Liberado', value: 'Liberado' },
    { label: 'Bloqueado', value: 'Bloqueado' },
    { label: 'Cancelado', value: 'Cancelado' },
  ]);

  const header = useMemo(
    () => [
      {
        id: 'poco_descricao',
        label: 'Posto',
        filter: { type: 'text' },
      },
      {
        id: 'tavi_nome',
        label: 'Tanque Vir.',
        filter: { type: 'text' },
      },
      {
        id: 'medi_descricao',
        label: 'Medidor',
        filter: { type: 'text' },
      },
      {
        id: 'term_descricao',
        label: 'Terminal',
        filter: { type: 'text' },
      },
      {
        id: 'bico_descricao',
        label: 'Descrição',
        filter: { type: 'text' },
      },
      {
        id: 'bico_numero',
        label: 'Bico',
        align: 'center',
        filter: { type: 'text' },
      },
      {
        id: 'bico_bomba_eletronica_string',
        label: 'Bomba Eletrônica',
        align: 'center',
        formatted: (value) =>
          optionSN.find((option) => option.label === value).value,
        filter: {
          type: 'select',
          options: optionSN,
        },
      },
      {
        id: 'bico_ultima_afericao',
        label: 'Ult. Aferição',
        align: 'center',
      },
      {
        id: 'bico_status_string',
        label: 'Status',
        align: 'center',
        formatted: (value) =>
          optionStatus.find((option) => option.label === value).value,
        filter: {
          type: 'select',
          options: optionStatus,
        },
      },
    ],
    []
  );

  return (
    <UnidataTable
      pdf
      excel
      reportOrder="bico_numero ASC"
      fixed
      read={recordFiltering}
      remove={deleteBico}
      form={MyForm}
      find={findBico}
      redux={data}
      header={header}
      detach="bico"
      keys={['bico_numero', 'poco_codigo']}
      view="VW_BICO"
      reportTitle="Cadastro de Bico"
    />
  );
}

export default Bico;
